// extracted by mini-css-extract-plugin
export var closeButton = "_dp-1";
export var closeX = "_dp-3";
export var container = "_dp-0";
export var image = "_dp-2";